"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
var Lantern_1 = require("./Lantern");
var terrain_1 = require("./terrain");
var zapIconSrc = require("./assets/zap-icon.svg");
var pictureIconSrc = require("./assets/picture-icon.svg");
var State = (function () {
    function State(_a) {
        var _this = this;
        var p5 = _a.p5, lanternImg = _a.lanternImg, width = _a.width, height = _a.height, speed = _a.speed;
        this.draw = function () {
            if (_this.stateType === 'static') {
                _this.p5.background(255, 0);
                _this.p5.strokeWeight(0);
                _this.p5.fill(255);
                var height_1 = _this.width < 640 ? 83 : 100;
                _this.p5.rect(0, 0, _this.width, height_1);
            }
            else {
                _this.p5.background(255);
                _this.p5.noStroke();
                _this.updateLanterns(0);
                _this.p5.fill(23, 34, 62);
                _this.drawTerrain(_this.terrainPoints3, _this.offsets[0]);
                _this.updateLanterns(1);
                _this.p5.fill(25, 32, 100);
                _this.drawTerrain(_this.terrainPoints2, _this.offsets[1]);
                _this.updateLanterns(2);
                _this.p5.fill(23, 62, 145);
                _this.drawTerrain(_this.terrainPoints1, _this.offsets[2]);
                _this.updateOffsets();
            }
        };
        this.toggleState = function () {
            if (_this.stateType === 'static') {
                _this.stateType = 'dynamic';
                _this.button.attribute('src', pictureIconSrc);
            }
            else {
                _this.stateType = 'static';
                _this.button.attribute('src', zapIconSrc);
            }
        };
        this.drawTerrain = function (points, offset) {
            _this.p5.beginShape();
            _this.p5.vertex(0, _this.p5.height);
            for (var x = offset; x < points.length + offset; x++) {
                _this.p5.vertex(x - offset, points[Math.floor(x % points.length)]);
            }
            _this.p5.vertex(_this.p5.width, _this.p5.height);
            _this.p5.endShape();
        };
        this.updateOffsets = function () {
            _this.offsets[0] = (_this.offsets[0] + _this.speed * 0.5) % _this.terrainPoints1.length;
            _this.offsets[1] = (_this.offsets[1] + _this.speed * 1) % _this.terrainPoints2.length;
            _this.offsets[2] = (_this.offsets[2] + _this.speed * 1.5) % _this.terrainPoints3.length;
        };
        this.updateLanterns = function (idx) {
            for (var i = 0; i < _this.lanterns[idx].length; i++) {
                _this.lanterns[idx][i].move();
                _this.lanterns[idx][i].draw();
            }
        };
        this.p5 = p5;
        var lanterns = [];
        var numLanterns = Math.round(width / 150);
        for (var i = 0; i < 3; i++) {
            var terrainLanterns = [];
            for (var j = 0; j < numLanterns; j++) {
                terrainLanterns.push(new Lantern_1.Lantern(p5, lanternImg, i));
            }
            lanterns.push(terrainLanterns);
        }
        this.stateType = 'static';
        this.lanternImg = lanternImg;
        this.speed = speed;
        this.terrainPoints1 = terrain_1.setupTerrain(width, height * 7 / 4, height / 4, 0.54);
        this.terrainPoints2 = terrain_1.setupTerrain(width, height, height / 4, 0.55);
        this.terrainPoints3 = terrain_1.setupTerrain(width, height * 3 / 4, height / 4, 0.56);
        this.lanterns = lanterns;
        this.offsets = [0, 0, 0];
        this.width = width;
        this.height = height;
        this.buttonX = this.width / 2;
        this.buttonY = this.height * 3 / 4;
        var button = this.p5.createImg(zapIconSrc).size(16, 16);
        button.style('padding', '8px');
        button.position(0, this.buttonY);
        button.center('horizontal');
        button.addClass('scrolling-terrain-btn');
        button.mousePressed(this.toggleState);
        this.button = button;
    }
    return State;
}());
exports.State = State;
